import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import Grid from '@mui/material/Grid2';

import { FeatureSource, ModelBase, PlayerObject } from "@models";
import { 
  Race, 
} from "@dndModels";
import { 
  CREATURE_TYPES 
} from "@dndModels/Constants";
import { SizeType } from "@dndModels/Types";

import StringBox from "@components/input/strings/StringBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import LoadingBox from "@components/input/LoadingBox";

import FeatureSourceInput from "@dndComponents/FeatureSourceInput";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function RaceEdit() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [obj, setObj] = useState<Race>(api.applyWorkingOn(new Race()));
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  useEffect(() => {
    if(!fetched) {
      load();
    }
  });
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const load = () => {
    setFetched(true);
    if (id && id !== "") {
      setLoading(true);
      const onComplete = (res: PlayerObject[] | ModelBase[]) => {
        if (res.length === 1 && res[0] instanceof Race) {
          setObj(res[0].clone());
          setChangeTime(common_util.get_time_number());
        }
        setLoading(false);
      };
      const onProgress = () => {};
      api.getObjectsWithCallbacks({ 
        data_type: "race", filter: { _id: id },
        onComplete, onProgress 
      });
    }
  }

  // const submit = () => {
  //   if (api.user && 
  //     (api.user.admin || 
  //       obj._id === "" || 
  //       obj.owner_id === api.user._id)) {
  //     setProcessing(true);
  //     if (!api.user.admin || obj.source_books_old.filter(o => o.id === "Personal").length > 0) {
  //       obj.owner_id = api.user._id;
  //     } else if (api.user.admin && obj.source_books_old.filter(o => o.type === "Homebrew").length === 0) {
  //       obj.owner_id = "";
  //     }
  //     api.upsertObject("race", obj).then(res => {
  //       setProcessing(false);
  //       setNavigateTo("/dandd/race");
  //     });
  //   }
  // }

  const height = window.innerHeight - 105;
  if (!fetched || loading) {
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  } else { 
    return (
      <FeatureSourceInput 
        obj={obj}
        data_type="race"
        disabled={disabled}
        change_time={change_time}
        onChange={(changed: FeatureSource) => {
          if (changed instanceof Race) {
            const new_obj = obj;
            new_obj.copy(changed);
            setObj(new_obj);
          }
        }}>
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 12
            }}>
            <SelectStringBox  
              name="Creature Type"
              options={CREATURE_TYPES}
              value={obj.creature_type}
              disabled={disabled}
              onChange={(value: string) => {
                const new_obj = obj;
                new_obj.creature_type = value;
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <StringBox 
              value={obj.age} 
              name="Age"
              disabled={disabled}
              onBlur={(value: string) => {
                const new_obj = obj;
                new_obj.age = value;
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <StringBox 
              value={obj.alignment} 
              name="Alignment"
              disabled={disabled}
              onBlur={(value: string) => {
                const new_obj = obj;
                new_obj.alignment = value;
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <StringBox 
              value={obj.size_description} 
              name="Size Description"
              disabled={disabled}
              onBlur={(value: string) => {
                const new_obj = obj;
                new_obj.size_description = value;
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            {/* { !reloading && */}
              <SelectStringBox 
                options={["Tiny","Small","Medium","Large","Huge","Gargantuan","Size from Subrace"]}
                values={common_util.get_size_strings(obj.sizes)} 
                multiple
                name="Size"
                disabled={disabled}
                onClose={(values: string[]) => {
                  const new_obj = obj;
                  const old_sizes = [...new_obj.sizes];
                  let new_sizes = common_util.get_size_numbers(values);
                  if (new_sizes.includes(8)) {
                    if (old_sizes.includes(8) && new_sizes.filter(o => o !== 8).length > 0) {
                      new_sizes = new_sizes.filter(o => o !== 8);
                      // setReloading(true);
                    } else if (!old_sizes.includes(8) && new_sizes.filter(o => o === 8).length > 0) {
                      new_sizes = [8];
                      // setReloading(true);
                    }
                  }
                  new_obj.sizes = new_sizes as SizeType[];
                  setObj(new_obj);
                  setChangeTime(common_util.get_time_number());
                }}
              />
            {/* } */}
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <StringBox 
              value={`${obj.speed}`} 
              name="Speed (in feet per round)"
              type="number"
              disabled={disabled}
              onBlur={(value: string) => {
                const new_obj = obj;
                new_obj.speed = +value;
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          </Grid>
        </Grid>
      </FeatureSourceInput>
    ); 
  }
}